let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2lGDt")).then(() => parcelRequire('4DVzy'));